@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.metric {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
  flex: 1;
  min-width: 0;
  padding: 15px;
  border-radius: 6px;
  background: var(--light-100, #fff);
  @include container-shadow;
  @include blur(35px);

  @include for-phone-only {
    box-shadow: none;
    border-radius: 5px;
    border: 1px solid var(--dark-4);
    padding: 0;
    gap: 0;
  }
}

.header {
  display: flex;
  width: 100%;
  gap: 25px;

  @include for-phone-only {
    flex-direction: column;
    gap: 5px;
    padding: 10px 15px;
    border-bottom: 1px solid var(--dark-4);
  }

  .name {
    display: flex;
    gap: 5px;
    align-items: center;

    .icon {
      display: flex;
      align-items: center;
      cursor: pointer;
    }
  }
}

.content {
  width: 100%;
}
